import { BeatLoader, ClipLoader } from 'react-spinners';

export const GLOBAL_ROUTER_PROGRESS_BAR_COLOR = '#873ba3';
export const LOADER_COLOR = '#2a471f';

enum LoaderVariant {
  BeatLoader = 'BeatLoader',
  Default = 'MoonLoader',
}

type LoaderProps = {
  variant?: LoaderVariant;
};

export function Loader({ variant = LoaderVariant.Default }: LoaderProps) {
  switch (variant) {
    case LoaderVariant.BeatLoader:
      return (
        <BeatLoader color={LOADER_COLOR} loading={true} size={20} aria-label="Loading Spinner" data-testid="loader" />
      );
    default:
      return (
        <ClipLoader color={LOADER_COLOR} loading={true} size={120} aria-label="Loading Spinner" data-testid="loader" />
      );
  }
}
